jQuery(function () {

    jQuery('.js-print').on('click', function(e) {
        e.preventDefault();

        window.print();
    });

});